<div class="input-group">
	<input type="number" step="0.01" class="form-control" name="value" [(ngModel)]="value" (change)="submit()" />
	<ng-select
		name="currency"
		[(ngModel)]="currency"
		[items]="currencies"
		placeholder="(wybierz)"
		bindLabel="name"
		bindValue="id"
		(change)="submit()"
	></ng-select>
</div>
